export const cookieConfigObj = {

  categories: {
    necessary: {
      enabled: true,  // this category is enabled by default
      readOnly: true  // this category cannot be disabled
    },
    analytics: {}
  },

  language: {
    default: 'cs',
    autoDetect: 'document',
    translations: {
      cs: {
        consentModal: {
          title: 'Nastavení cookies',
          description: 'Na našich stránkách využíváme cookies.',
          acceptAllBtn: 'Přijmout vše',
          //acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Nastavení'
        },
        preferencesModal: {
          title: 'Nastavení preferencí',
          acceptAllBtn: 'Přijmout vše',
          // acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Přijmout pouze nezbytné',
          closeIconLabel: 'Zavřít',
          sections: [
            {
              //title: 'Somebody said ... cookies?',
              description: 'Zde si můžete nastavit Vaši preferenci používání cookies na tomto webu.'
            },
            {
              title: 'Nezbytné cookies',
              description: 'Tyto cookies jsou nezbytné pro správné fungování webu, např. pro přihlášení.',

              //this field will generate a toggle linked to the 'necessary' category
              linkedCategory: 'necessary'
            },
            {
              title: 'Analytické cookies',
              description: 'Za účelem sledování návštěvnosti tohoto webu využíváme analytických cookies. Tyto cookies neshromažďují Vaše osobní údaje.',
              linkedCategory: 'analytics'
            },
            // {
            //   title: 'More information',
            //   description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
            // }
          ]
        }
      },
      en: {
        consentModal: {
          title: 'We use cookies',
          description: 'Cookie modal description',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Manage Individual preferences'
        },
        preferencesModal: {
          title: 'Manage cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Accept current selection',
          closeIconLabel: 'Close modal',
          sections: [
            {
              title: 'Somebody said ... cookies?',
              description: 'I want one!'
            },
            {
              title: 'Strictly Necessary cookies',
              description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',

              //this field will generate a toggle linked to the 'necessary' category
              linkedCategory: 'necessary'
            },
            {
              title: 'Performance and Analytics',
              description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
              linkedCategory: 'analytics'
            },
            {
              title: 'More information',
              description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
            }
          ]
        }
      }
    }
  }
}